import React, { useEffect } from 'react';
import FilterWrap from '../FilterWrap';
import { IComponentPageTabType } from "../type";
import MarqueeInfo from '../../MarqueeInfo';
import { shallowEqual, useSelector } from 'umi';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';
import Render from '@/pages/dashboard/components/PageContainer/Render';
import { useProps } from '../Render/hooks';
interface IContentWrapProps {
  config: IComponentPageTabType;
  timeZone: string;
}

// tab标签页，跑马灯、打点等相关处理
export default (props: IContentWrapProps) => {
  const { config: content , timeZone } = props;
  const { data, changeData } = useProps({ ...props, config: content });
  const { isHaveNotification, logConfig, notificationPath, path, children = [], filters = [] } = content || {};

  const { gameCode, menuId } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
      menuId: state?.dashboard?.currentMenu?.id, shallowEqual
    };
  }, shallowEqual);

  // 打点处理，useBuriedPoint不符合需求，切换tab的时候无法重新打点，在此单独处理打点信息
  useEffect(() => {
    const { pageId, pageName, extInfo, pagePath } = logConfig || {};
    if (!logConfig) return;
    const logObj = {
      menuId: menuId,
      pageId: pageId,
      pageName: pageName,
      extInfo: extInfo,
      pagePath: pagePath,
      uid: gameCode,
      typeId: 'dashboard_pc_v2'
    };
    buriedPoint(logObj);
  }, [content]);

  return <>
    {isHaveNotification && <MarqueeInfo pagePath={notificationPath ? notificationPath : path} />}
    {
      children?.map((item, index) => {
        return <>
          <Render config={item} key={item?.name + index} data={data} changeData={changeData} />
        </>;
      })
    }
    {
      filters?.map((item, index) => {
        return <FilterWrap
          timeZone={item?.timeZone || timeZone}
          data={data}
          changeData={changeData}
          pagePath={path}
          key={path + item?.name + index}
          config={item}
          filterIndex={index}
          logConfig={logConfig}
        />;
      })
    }
  </>;
};
